import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';

import Button from '../../Button';
import { enhance } from './enhance';
import Shape from '../../common/Shape';
import Loader from '../../common/Loader';
import AppointmentHeader from '../Components/AppointmentHeader';
import {
  redirectToLocations,
  redirectToVisitType,
} from '../../../utils/appointments/redirect-utils';

import styles from './styles.styl';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

function AppointmentPublixInfo({
  intl: { formatMessage },
  data,
  loadingPublixInfo,
}) {
  usePageView('Get Care | Publix');

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.publix" />
      <AppointmentHeader
        type="name"
        title="visitType.publix"
        handleBack={redirectToVisitType}
      />
      {loadingPublixInfo && <Loader />}
      {!loadingPublixInfo && (
        <Fragment>
          <div className={styles.infoWrapper}>
            {data
              .sort(item => item.order)
              .map(({ id, order, content, attachment }) => (
                <Shape
                  key={id}
                  className={styles.info}
                  renderPrimary={
                    order === 1
                      ? () => formatMessage({ id: 'visitType.publix.title' })
                      : () => ''
                  }
                  renderSecondary={() => content}
                  renderLeft={() => (
                    <img
                      style={{ width: 42 }}
                      src={attachment.url}
                      alt={content}
                    />
                  )}
                />
              ))}
          </div>
          <Button
            color="primary"
            className={styles.button}
            onClick={() => redirectToLocations()}
          >
            {formatMessage({ id: 'task.seeLocations' })}
          </Button>
        </Fragment>
      )}
    </Fragment>
  );
}

AppointmentPublixInfo.propTypes = {
  data: PropTypes.array,
  intl: PropTypes.object,
  loadingPublixInfo: PropTypes.bool,
};
export default enhance(AppointmentPublixInfo);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPublixInfo/index.jsx